<template>
  <div v-loading="loading" class="establish">
    <div class="establish_TitleArea">
      <h3 class="title">创建落地页</h3>
      <i class="icon" @click="$emit('close')">X</i>
    </div>
    <div class="establish_main">
      <div class="content">
        <SeInput :stylek="{margin:'0px 10px'}" placeholder="请选择公共落地页" @change="landingPage = $event" @input="landingPageInput" @blur="$event()" />
      </div>
    </div>

    <div class="establish_button">
      <el-button type="primary" @click="determine">确定</el-button>
    </div>
  </div>
</template>

<script>
import { getNativePageList } from '@/api/nativePAGE.js'
import SeInput from './seInput/index.vue'
export default {
  components: {
    SeInput
  },
  data() {
    return {
      loading: false,
      landingPage: null
    }
  },
  async created() {

  },
  methods: {
    async landingPageInput(obj = {}) {
      const data = await getNativePageList(obj.value ? { page_name: obj.value, page_size: 1000 } : { page_size: 1000 })
      const s = data.data.list.map((item) => {
        return {
          ...item,
          name: item.canvas_name
        }
      })
      obj.cb(s)
    },

    determine() {
      !this.landingPage && this.$message({
        message: '请选择公共原生页',
        type: 'warning'
      })

      if (this.landingPage) {
        this.$store.commit('publicNativePAGE/setCurrentNativePageData', this.landingPage)
        this.$router.replace({
          path: '/newNativePromotionPage',
          query: {
            account_id: this.$route.query.account_id
          }
        })
      }
    }
  }
}
</script>

<style lang="less" scoped>
.establish{
   width: 780px;
   height: 500px;
   background-color: #fff;
   border-radius: 7px;
   position: relative;
   top: 50%;
   transform: translate(-50%, -50%);
   left: 50%;
   display: flex;
   flex-direction: column;

   .establish_TitleArea{
     width: 100%;
     height: 50px;
     border-bottom: 1px solid rgb(160, 160, 160);
     display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 20px;
     .title{
             font-weight: bold;
     }
        .icon{
             font-style: normal;
             cursor: pointer;
             &:hover{
               font-weight: bold;
             }
   }
   }

   .establish_main{
     padding-top: 20px;
     display: flex;
     justify-content: center;
     flex-grow: 1;

     .content{
          width: 80%;
          display: flex;
          .el-autocomplete{
            width: 100%;
          }
     }
   }

   .establish_button{
     padding: 10px;
     border-top: 1px solid #ccc;
     display: flex;
     justify-content: flex-end;
   }

}
</style>
